//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";
import ReactExport from "react-data-export";
import * as moment from "moment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export default function CiprianReportXLSX({ states, date, page, reportId }) {
  console.log({reportId});
  const { excelData } = states;
  let excelData1, excelData2, excelData3, excelData4;
  let transactions1, transactions2, transactions3, transactions4, transactions;
  if (reportId == 1) {
    excelData1 = excelData?.ciprian?.filter(i => i.value5 == 'Overall').sort((a, b) => a.value1.localeCompare(b.value1))
    excelData2 = excelData?.ciprian?.filter(i => i.value5 == 'Active').sort((a, b) => a.value1.localeCompare(b.value1))
    excelData3 = excelData?.ciprian?.filter(i => i.value5 == 'In-Active').sort((a, b) => a.value1.localeCompare(b.value1))
    excelData4 = excelData?.ciprian?.filter(i => i.value5 == 'toBeInActive').sort((a, b) => a.value1.localeCompare(b.value1))

    transactions1 = excelData1?.map((t) => Object.entries(t).slice(0, Object.entries(t).length-1).map((obj) => { return { value: obj[1] ? obj[1].toLocaleString('en-US') : "0" } }))
    transactions2 = excelData2?.map((t) => Object.entries(t).slice(0, Object.entries(t).length-1).map((obj) => { return { value: obj[1] ? obj[1].toLocaleString('en-US') : "0" } }))
    transactions3 = excelData3?.map((t) => Object.entries(t).slice(0, Object.entries(t).length-1).map((obj) => { return { value: obj[1] ? obj[1].toLocaleString('en-US') : "0" } }))
    transactions4 = excelData4?.map((t) => Object.entries(t).slice(0, Object.entries(t).length-1).map((obj) => { return { value: obj[1] ? obj[1].toLocaleString('en-US') : "0" } }))
  } else {
    transactions = excelData?.ciprian?.map((t) => Object.entries(t).map((obj) => { return { value: obj[1] ? obj[1].toLocaleString('en-US') : "0" } }))
  }

  let headings = excelData?.cipirianName ? excelData?.cipirianName[0] : { "title": "title" }

  // switch (reportId) {
  //   case 1:
  //     transactions = excelData?.ciprian?.map((t) =>Object.entries(t).map((obj)=>{return{value:obj[1]?obj[1].toLocaleString('en-US'):"0"}}))
  //     break;
  //   case 2:
  //     transactions = excelData?.ciprian?.map((t) =>Object.entries(t).map((obj)=>{return{value:obj[1]?obj[1].toLocaleString('en-US'):"0"}}))
  //     break;
  //   case 3:
  //     transactions = excelData?.ciprian?.map((t) =>Object.entries(t).map((obj)=>{return{value:obj[1]?obj[1].toLocaleString('en-US'):"0"}}))
  //     break;
  //   case 4:
  //     transactions = excelData?.ciprian?.map((t) =>Object.entries(t).map((obj)=>{return{value:obj[1]?obj[1].toLocaleString('en-US'):"0"}}))
  //     break;
  //   case 5:
  //     transactions = excelData?.ciprian?.map((t) =>Object.entries(t).map((obj)=>{return{value:obj[1]?obj[1].toLocaleString('en-US'):"0"}}))
  //     break;
  // }


  let borderStyles = {
    border: {
      top: { style: "thin", color: { rgb: "00000000" } },
      bottom: { style: "thin", color: { rgb: "00000000" } },
      left: { style: "thin", color: { rgb: "00000000" } },
      right: { style: "thin", color: { rgb: "00000000" } },
    },
  };

  
  let headerEnrollStyles = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    fill: { patternType: "solid", fgColor: { rgb: "00315496" } },
    ...borderStyles,
  };


  let header1Styles = {
    style: {
      font: { bold: true },
      alignment: { horizontal: "center" },
      ...borderStyles,
    },
  };
  let coulumns = Object.entries(headings).map((obj) => { return { title: obj[1] ? obj[1] : "", width: { wch: 30 }, style: { ...headerEnrollStyles } } })

  // switch (reportId) {
  //   case 1:
  //     coulumns =Object.entries(headings).map((obj)=>{return{title:obj[1]?obj[1]:"", width: { wch: 30 }, style: { ...headerEnrollStyles }}})
  //     break;
  //   case 2:
  //     coulumns =Object.entries(headings).map((obj)=>{return{title:obj[1]?obj[1]:"", width: { wch: 30 }, style: { ...headerEnrollStyles }}})
  //     break;
  //   case 3:
  //     coulumns =Object.entries(headings).map((obj)=>{return{title:obj[1]?obj[1]:"", width: { wch: 30 }, style: { ...headerEnrollStyles }}})
  //     break;
  //   case 4:
  //     // coulumns = [
  //     //   { title: "Category", width: { wch: 17 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Outstanding Points as of Today", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 1", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 2", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 3", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 4", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 5", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 6", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 7", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 8", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 9", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 10", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 11", width: { wch: 30 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 12", width: { wch: 30 }, style: { ...headerEnrollStyles } }
  //     // ]
  //     coulumns =Object.entries(headings).map((obj)=>{return{title:obj[1]?obj[1]:"", width: { wch: 30 }, style: { ...headerEnrollStyles }}})



  //     break;
  //   case 5:
  //     // coulumns = [
  //     //   { title: "Category", width: { wch: 17 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Enrollment Month", width: { wch: 17 }, style: { ...headerEnrollStyles } },
  //     //   { title: "MonthDiff    ", width: { wch: 17 }, style: { ...headerEnrollStyles } },
  //     //   { title: "NoOfAcc", width: { wch: 17 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Program Type", width: { wch: 17 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Total Points", width: { wch: 17 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 1", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 2", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 3", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 4", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 5", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 6", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 7", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 8", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 9", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 10", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 11", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 12", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 13", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 14", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 15", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 16", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 17", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 18", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 19", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 20", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 21", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 22", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 23", width: { wch: 29 }, style: { ...headerEnrollStyles } },
  //     //   { title: "Points to be Expired Month 24", width: { wch: 29 }, style: { ...headerEnrollStyles } }
  //     // ]
  //     coulumns =Object.entries(headings).map((obj)=>{return{title:obj[1]?obj[1]:"", width: { wch: 30 }, style: { ...headerEnrollStyles }}})

  //     break;
  // }

  let multiDataSet = [
    {
      columns: [...(coulumns || [])],
      data: [...(transactions || [])]
    },
  ];

  if (reportId == 1) {
    multiDataSet = [
      {
        columns: [{ title: "All Accounts", width: { wch: 17 }, style: { ...headerEnrollStyles } }],
        data: []
      },
      {
        columns: [...(coulumns || [])],
        data: [...(transactions1 || [])]
      },
      {
        columns: [{ title: "", width: { wch: 17 } }],
        data: []
      },
      {
        columns: [{ title: "Active Accounts", width: { wch: 17 }, style: { ...headerEnrollStyles } }],
        data: []
      },
      {
        columns: [...(coulumns || [])],
        data: [...(transactions2 || [])]
      },
      {
        columns: [{ title: "", width: { wch: 17 } }],
        data: []
      },
      {
        columns: [{ title: "In-Active Accounts", width: { wch: 17 }, style: { ...headerEnrollStyles } }],
        data: []
      },
      {
        columns: [...(coulumns || [])],
        data: [...(transactions3 || [])]
      },
      {
        columns: [{ title: "", width: { wch: 17 } }],
        data: []
      },
      {
        columns: [{ title: "Active accounts inprogress to deactivate", width: { wch: 17 }, style: { ...headerEnrollStyles } }],
        data: []
      },
      {
        columns: [...(coulumns || [])],
        data: [...(transactions4 || [])]
      },
    ];
  }

  // console.log({transactions1, transactions2, transactions3});

  return (
    <ExcelFile
      filename={
        `${page}` +
        " " +
        moment(new Date()).format("MM-DD-YYYY,h:mm A")
      }
      element={
        <button id="csv" style={{ display: "none" }}>
          Hidden btn
        </button>
      }
    >
      <ExcelSheet dataSet={multiDataSet} name="Organization" />
    </ExcelFile>
  );
}
